import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createAppointment = (data) =>
  axios.post(`${API}/appointments`, data).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);

export const fetchAdminAppointments = (passcode) =>
  axios
    .get(`${API}/admin/appointments`, { headers: { "X-Admin-Passcode": passcode } })
    .then((r) => r.data);

export const createCheckout = (data) =>
  axios.post(`${API}/payments/checkout`, data).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const updateAppointmentStatus = (id, status, passcode) =>
  axios
    .post(`${API}/admin/appointments/${id}/status`, { status }, { headers: { "X-Admin-Passcode": passcode } })
    .then((r) => r.data);

export const triggerReminders = (passcode) =>
  axios
    .post(`${API}/admin/send-reminders`, {}, { headers: { "X-Admin-Passcode": passcode } })
    .then((r) => r.data);
